const simulateProd = false;

export const publicPath = (path: string, withPublic = true): string => {
  const isProd = process.env.NODE_ENV === (simulateProd ? 'development' : 'production');
  const prefix = process.env.NEXT_PUBLIC_PREFIX || '';
  const publicSegment = withPublic ? '/public' : '';

  return isProd ? `${prefix}${publicSegment}${path}` : path;
}
